"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const initializer = __importStar(require("./offchainInitializer"));
const offchainPriceHelper_1 = __importDefault(require("./offchainPriceHelper"));
const offchainAPRHelper_1 = __importDefault(require("./offchainAPRHelper"));
const offchainSolidexHelper_1 = __importDefault(require("./offchainSolidexHelper"));
const account_1 = __importDefault(require("./account"));
const offchainEndpointManager_1 = __importDefault(require("./offchainEndpointManager"));
const offchainLendingVault_1 = __importDefault(require("./offchainLendingVault"));
const configManager_1 = __importDefault(require("./configManager"));
class Offchain {
    constructor(cfg) {
        this.getPriceHelper = () => this.priceHelper;
        this.getSolidexHelper = () => this.solidexHelper;
        this.getConfigManager = () => this.configManager;
        this.getAPRHelper = () => this.aprHelper;
        /**
         * TODO
         * Potrei organizzare in:
         * - lendingPoolData
         * - usersData
         * - tvlData
         * - ximxData
         * - lendingVaultData
         */
        // TODO make everything protected
        // Fetchers
        this.apolloFetcher = initializer.apolloFetcher;
        this.fetchLendingPools = initializer.fetchLendingPools;
        this.fetchLendingPoolsPast = initializer.fetchLendingPoolsPast;
        this.fetchPastVolume = initializer.fetchPastVolume;
        this.fetchCurrentVolumeAndReserves = initializer.fetchCurrentVolumeAndReserves;
        this.fetchImpermaxChefRewardRates = initializer.fetchImpermaxChefRewardRates;
        this.fetchUniswapAPR = initializer.fetchUniswapAPR;
        this.fetchBlockByTimestamp = initializer.fetchBlockByTimestamp;
        this.initializeLendingPoolsData = initializer.initializeLendingPoolsData;
        this.getLendingPoolsData = initializer.getLendingPoolsData;
        this.getLendingPoolData = initializer.getLendingPoolData;
        this.initializeTvlData = initializer.initializeTvlData;
        this.getTvlData = initializer.getTvlData;
        this.fetchUserData = initializer.fetchUserData;
        this.initializeUserData = initializer.initializeUserData;
        this.getUserData = initializer.getUserData;
        this.initializeXimxData = initializer.initializeXimxData;
        this.getXimxData = initializer.getXimxData;
        this.fetchLendingVaults = initializer.fetchLendingVaults;
        this.initializeLendingVaultsData = initializer.initializeLendingVaultsData;
        this.getLendingVaultsData = initializer.getLendingVaultsData;
        this.getLendingVaultData = initializer.getLendingVaultData;
        this.fetchLendingVaultsUserData = initializer.fetchLendingVaultsUserData;
        this.initializeLendingVaultsUserData = initializer.initializeLendingVaultsUserData;
        this.getLendingVaultsUserData = initializer.getLendingVaultsUserData;
        this.fetchWhitelist = initializer.fetchWhitelist;
        this.initializeWhitelistData = initializer.initializeWhitelistData;
        this.getWhitelistData = initializer.getWhitelistData;
        this.getWhitelistState = initializer.getWhitelistState;
        this.network = cfg.network;
        this.chainId = cfg.chainId;
        this.whitelistedPairs = cfg.whitelistedPairs ? cfg.whitelistedPairs : {};
        this.priceHelper = new offchainPriceHelper_1.default(this);
        this.solidexHelper = new offchainSolidexHelper_1.default(this);
        this.configManager = new configManager_1.default(this);
        this.aprHelper = new offchainAPRHelper_1.default(this);
        this.endpointManager = new offchainEndpointManager_1.default();
        this.accounts = {};
        this.usersData = {};
        this.lendingVaultsUsersData = {};
    }
    cleanCache() {
        this.lendingPoolsData = null;
        this.usersData = {};
        this.lendingVaultsData = null;
        this.lendingVaultsUsersData = {};
        this.tvlData = null;
        this.ximxData = null;
        this.whitelistData = null;
        this.priceHelper.cleanCache();
        this.solidexHelper.cleanCache();
        this.configManager.cleanCache();
        this.aprHelper.cleanCache();
    }
    getLendingPool(factory, pairAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getLendingPoolsData(); // make sure that lending pools are initialized
            return this.lendingPools[factory][pairAddress];
        });
    }
    getLendingVault(vaultAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.getLendingVaultsData(); // make sure that lending vaults are initialized
            if (!this.lendingVaults)
                this.lendingVaults = {};
            if (!this.lendingVaults[vaultAddress])
                this.lendingVaults[vaultAddress] = new offchainLendingVault_1.default(this, vaultAddress);
            return this.lendingVaults[vaultAddress];
        });
    }
    getAccount(accountAddress) {
        if (!this.accounts[accountAddress])
            this.accounts[accountAddress] = new account_1.default(this, accountAddress);
        return this.accounts[accountAddress];
    }
    /**
     * DATA GETTERS
     */
    // Pair List
    getPairList() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            const lendingPoolData = yield this.getLendingPoolsData();
            let factory;
            for (factory in lendingPoolData) {
                for (const pairAddress in lendingPoolData[factory]) {
                    result.push({ pairAddress, factory });
                }
            }
            return result;
        });
    }
    getPairData(factory, pairAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPool = yield this.getLendingPool(factory, pairAddress);
            const totalBorrowsUSD = yield lendingPool.getTotalBorrowsUSD();
            return { pairAddress, factory, totalBorrowsUSD };
        });
    }
    getPairListWithData(pairList) {
        return __awaiter(this, void 0, void 0, function* () {
            const requests = [];
            for (const pair of pairList) {
                requests.push(this.getPairData(pair.factory, pair.pairAddress));
            }
            return Promise.all(requests);
        });
    }
    // Crosschain TVL Data
    getCrossChainTVL() {
        return __awaiter(this, void 0, void 0, function* () {
            // Try llama
            const llamaTvl = yield this.getAPRHelper().getImpermaxTvl();
            if (llamaTvl)
                return llamaTvl;
            // Fallback to subgraph
            const tvlData = yield this.getTvlData();
            return tvlData.crossChainTVLUSD;
        });
    }
    getCrossChainTotalValueSupplied() {
        return __awaiter(this, void 0, void 0, function* () {
            const tvlData = yield this.getTvlData();
            return tvlData.crossChainSupplyUSD;
        });
    }
    getCrossChainTotalValueBorrowed() {
        return __awaiter(this, void 0, void 0, function* () {
            const tvlData = yield this.getTvlData();
            return tvlData.crossChainBorrowUSD;
        });
    }
    // This chain TVL Data
    getTotalValueLocked() {
        return __awaiter(this, void 0, void 0, function* () {
            // Try llama
            const { tvl } = yield this.getAPRHelper().getLlamaTvlAndBorrows(this.network);
            // Fallback to subgraph
            const tvlData = yield this.getTvlData();
            return tvl && tvl > tvlData.totalBalanceUSD ? tvl : tvlData.totalBalanceUSD;
        });
    }
    getTotalValueSupplied() {
        return __awaiter(this, void 0, void 0, function* () {
            // Try llama
            const { totalSupplied } = yield this.getAPRHelper().getLlamaTvlAndBorrows(this.network);
            // Fallback to subgraph
            const tvlData = yield this.getTvlData();
            return totalSupplied && totalSupplied > tvlData.totalSupplyUSD ? totalSupplied : tvlData.totalSupplyUSD;
        });
    }
    getTotalValueBorrowed() {
        return __awaiter(this, void 0, void 0, function* () {
            // Try llama
            const { borrowed } = yield this.getAPRHelper().getLlamaTvlAndBorrows(this.network);
            // Fallback to subgraph
            const tvlData = yield this.getTvlData();
            return borrowed && borrowed > tvlData.totalBorrowsUSD ? borrowed : tvlData.totalBorrowsUSD;
        });
    }
    // IMX Staking
    getXIMXAPY() {
        return __awaiter(this, void 0, void 0, function* () {
            const ximxData = yield this.getXimxData();
            if (!ximxData)
                return 0;
            return Math.pow(1 + parseFloat(ximxData.dailyAPR), 365) - 1;
        });
    }
    getProtocolChart() {
        return __awaiter(this, void 0, void 0, function* () {
            const protocolTvlChart = yield this.getAPRHelper().getProtocolTvlChart();
            return protocolTvlChart;
        });
    }
    getProtocolChainChart(chain) {
        return __awaiter(this, void 0, void 0, function* () {
            const chainTvlCharts = yield this.getAPRHelper().getChainTvlChart(chain);
            return chainTvlCharts;
        });
    }
}
exports.default = Offchain;
